module.exports = __webpack_public_path__ + "static/media/galerija_2017 (8).ef5ed794.jpg";